type ContributorLike = {
    slug?: string | null;
    name?: string | null;
    is_owner?: boolean | null;
};

type PluginAuthorSource = {
    author?: string | null;
    author_profile?: { url?: string | null } | null;
    contributors?: ContributorLike[] | null;
};

const normalize = (value: unknown): string => String(value ?? "").trim();

export const getWordPressProfileSlugFromUrl = (url?: string | null): string | null => {
    const candidate = normalize(url);
    if (!candidate) return null;

    const match = candidate.match(/https?:\/\/profiles\.wordpress\.org\/([^/#?]+)(?:[\/#?]|$)/i);
    if (!match?.[1]) return null;
    return normalize(match[1]).toLowerCase() || null;
};

export const getAuthorPageHref = (authorSlug: string): string => `/author/${encodeURIComponent(authorSlug)}`;

export const getPluginAuthorSlug = (plugin: PluginAuthorSource): string | null => {
    const owner = plugin.contributors?.find((contributor) => Boolean(contributor?.is_owner) && normalize(contributor.slug));
    if (owner?.slug) return normalize(owner.slug).toLowerCase();

    const fromProfile = getWordPressProfileSlugFromUrl(plugin.author_profile?.url);
    if (fromProfile) return fromProfile;

    const authorName = normalize(plugin.author).toLowerCase();
    if (!authorName) return null;

    const matchByName = plugin.contributors?.find((contributor) => normalize(contributor.name).toLowerCase() === authorName);
    if (matchByName?.slug) return normalize(matchByName.slug).toLowerCase();

    return null;
};

